module.exports = __webpack_public_path__ + "img/jahwa.7e1f21d9.png";